export const changeOperation = operation => {
  return (dispatch) => {
    dispatch({
      type: 'changeOperation',
      payload: operation
    })
  }
}

export const updateInput = equation => {
  return (dispatch) => {
    dispatch({
      type: 'equate',
      payload: equation
    })
  }
}

export const setResult = result => {
  return (dispatch) => {
    dispatch({
      type: 'setResult',
      payload: result
    })
  }
}
